<template>
    <svg width="7" height="23" viewBox="0 0 7 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="19.5" r="2.5"/>
        <circle cx="2.5" cy="11.5" r="2.5"/>
        <circle cx="2.5" cy="3.5" r="2.5"/>
    </svg>
</template>
